// React & Redux
import React, { Component } from "react"
import { connect } from "react-redux"

import AppContainer from "./AppContainer"

import { View, Text, Animated, StyleSheet, StatusBar } from "react-native"

// Routing
import { Router, Switch, Link, Route } from "./routing/Routing"
import PrivateRoute from "./routing/PrivateRoute"
import { TranslatorProvider } from "react-translate"

// Application page components
import Login from "./components/Login/LoginComponent"
import RegisterComponent from "./components/Login/RegisterComponent"
import LandingComponent from "./components/Public/LandingPage/LandingComponent"
import CguvComponent from "./components/Public/CguvPage/CguvComponent"
import MentionsLegalesComponent from "./components/Public/MentionsLegalesPage/MentionsLegalesComponent"
import PartenaireComponent from "./components/Public/PartenairePage/PartenaireComponent"
import FonctionComponent from "./components/Public/FonctionPage/FonctionComponent"
import ProtectedAcceuil from "./components/Protected/ProtectedComponent"
import SupportComponent from "./components/Public/SupportPage/SupportComponent"
import ArtisansComponent from "./components/Public/ArtisansPage/ArtisansComponent"
import ProAccueil from "./components/Pro/ProComponent"

import allTranslations from "./translate/AllTranslations"

const fallBack_lang = "en_GB"
const mapStateToProps = state => ({
  app: state.app
})

class ConnectedApp extends Component {
  render() {
    // Switching cases to avoid the following error :
    // Call to `require` expect exactly 1 string literal argument
    var translations = allTranslations[this.props.app.lang || fallBack_lang]

    return (
      <TranslatorProvider translations={translations}>
        <Router>
          <AppContainer>
            <Route exact path="/" component={LandingComponent} />
            <Route path="/cguv" component={CguvComponent} />
            <Route
              path="/termsandconditions"
              component={MentionsLegalesComponent}
            />
            <Route path="/partenaire" component={PartenaireComponent} />
            <Route path="/functions" component={FonctionComponent} />
            <Route path="/login" component={LandingComponent} />
            <Route path="/Support" component={SupportComponent} />
            <Route path="/pro" component={ArtisansComponent} />
            <Route path="/register" component={RegisterComponent} />
            <PrivateRoute path="/homepage" component={ProtectedAcceuil} />
            <PrivateRoute path="/works" component={ProtectedAcceuil} />
            <PrivateRoute path="/lists" component={ProtectedAcceuil} />
            <PrivateRoute path="/listsnew" component={ProtectedAcceuil} />
            <PrivateRoute path="/listdetail/:id" component={ProtectedAcceuil} />
            <PrivateRoute path="/subs" component={ProtectedAcceuil} />
            <PrivateRoute path="/settings" component={ProtectedAcceuil} />
            <PrivateRoute path="/contact" component={ProtectedAcceuil} />
            <PrivateRoute path="/recherche" component={ProtectedAcceuil} />
            <Route path="/mtpro" component={ProAccueil} />{" "}
            {/* TODO Use another component than Private Route to ensure user is logged through Pro acc*/}
          </AppContainer>
        </Router>
      </TranslatorProvider>
    )
  }
}

const App = connect(mapStateToProps)(ConnectedApp)
export default App

const styles = StyleSheet.create({
  app: {
    flex: 1
  },
  appHeader: {
    flex: 1,
    backgroundColor: "#222",
    padding: 20,
    justifyContent: "center",
    alignItems: "center"
  },
  headerImage: {
    width: 200,
    height: 200,
    flex: 3
  },
  appTitle: {
    flex: 1,
    fontSize: 16,
    color: "white"
  },
  appSubtitle: {
    color: "white"
  },
  appIntro: {
    flex: 3,
    fontSize: 30,
    textAlign: "center"
  }
})



// WEBPACK FOOTER //
// ./src/App.js